// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, Typography } from '@mui/material';

export const SecuredPartyPopover: React.FC = () => {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="body2">Awaiting counterparty to allocate assets.</Typography>
      <Typography variant="body2">Please check with counterparty regarding the status.</Typography>
    </Box>
  );
};
